import { render, staticRenderFns } from "./navigationMenu.vue?vue&type=template&id=efd09f14&scoped=true"
import script from "./navigationMenu.vue?vue&type=script&lang=js"
export * from "./navigationMenu.vue?vue&type=script&lang=js"
import style0 from "./navigationMenu.vue?vue&type=style&index=0&id=efd09f14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd09f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd09f14')) {
      api.createRecord('efd09f14', component.options)
    } else {
      api.reload('efd09f14', component.options)
    }
    module.hot.accept("./navigationMenu.vue?vue&type=template&id=efd09f14&scoped=true", function () {
      api.rerender('efd09f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authorityManagement/navigationMenu.vue"
export default component.exports